import { Injectable } from '@angular/core';
import {MdDialog, MdDialogConfig, MdSnackBar, MdSnackBarConfig} from '@angular/material';
import {Observable} from 'rxjs/Observable';
import {CloneContractDialogComponent} from '../../components/clone-contract-dialog/clone-contract-dialog.component';

@Injectable()
export class CloneContractService {

    constructor(public dialog: MdDialog, public snackBar: MdSnackBar) { }

    /**
     *
     * @param {string} name Name of the item to delete
     * @param {string} title Title to be displayed at the top of the dialog
     * @param {string} description Description of the consequences for deleting
     * @param {number} id ID of the item to delete
     * @return {Observable<number>} when a user deletes an item
     */
    openDialog(contractId: number): Observable<number> {
        return this.dialog
            .open(CloneContractDialogComponent, <MdDialogConfig> {
                // data to be passed in
                data: {
                    contractId : contractId
                }
            })
            .afterClosed()
            .skipWhile((result) => result === 'cancel' || result === undefined || result === null)
            .do(() => this.snackBar.open('Item cloned!', 'Dismiss', <MdSnackBarConfig>{duration: 3000}));
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/clone-contract/clone-contract.service.ts